import { ReactComponent as MaleExcelLogoNew } from 'assets/male-excel-white.svg';
import useTailwindBreakpoints from 'hooks/use-tailwind-breakpoints';
import { ReactComponent as TimeToComplete } from 'assets/time-to-complete.svg';
import { ReactComponent as Lock } from 'assets/lock-01.svg';

interface BlackBandHeaderProps {
  timeToComplete?: string;
  isSecureCheckout?: boolean;
  showProgressBar?: boolean;
}

export default function Header(props: BlackBandHeaderProps) {
  const largeScreen = useTailwindBreakpoints().sizeUp('md');
  const { timeToComplete, isSecureCheckout = false } = props;

  return (
    <div className='container mx-auto max-w-screen-lg relative font-myFont'>
      <div className='mx-2 my-2 md:my-3 flex justify-between py-2 gap-5'>
        <div className='pl-3 lg:pl-0'>
          <MaleExcelLogoNew
            width={largeScreen ? '12.5rem' : '9.5rem'}
            height='100%'
          />
        </div>

        <div className='flex flex-col'>
          <div className='mr-1 pr-2 text-base font-normal text-white md:mr-0 md:text-base md:font-semibold'>
            {timeToComplete && (
              <div className='flex items-center justify-center'>
                <TimeToComplete />
                <div className='ml-1 max-w-36 text-xs font-normal'>
                  Less than {timeToComplete} to complete
                </div>
              </div>
            )}
            {isSecureCheckout && (
              <div className='flex items-center justify-center'>
                <Lock />
                <div className='ml-1 max-w-36 text-xs font-normal'>
                  Secure <br />Checkout
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
